import { createAction } from 'utils/redux'

export const fetchCallsMade = createAction('FETCH_CALLS_BOOKED')
export const fetchCallsMadeFailed = createAction('FETCH_CALLS_BOOKED_FAILED')
export const fetchCallsMadeSuccess = createAction('FETCH_CALLS_BOOKED_SUCCESS')

export const fetchCallData = createAction('FETCH_CALL_DATA')
export const fetchCallDataFailed = createAction('FETCH_CALL_DATA_FAILED')
export const fetchCallDataSuccess = createAction('FETCH_CALL_DATA_SUCCESS')

export const exportCallData = createAction('EXPORT_CALL_DATA')
export const exportCallDataFailed = createAction('EXPORT_CALL_DATA_FAILED')
export const exportCallDataSuccess = createAction('EXPORT_CALL_DATA_SUCCESS')
